import { render, staticRenderFns } from "./SetSellingPreferences.vue?vue&type=template&id=4d8aa28d&"
import script from "./SetSellingPreferences.vue?vue&type=script&lang=js&"
export * from "./SetSellingPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports